import { NormalizedFMSTenantInterface, SaveTenantInterface, TenantInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - ../../../../apps/server/src/API/Tenants/Tenants.Controller.ts
export class TenantsAPI {
  static async createTenant(orgId: number, tenant?: SaveTenantInterface) {
    return APIService.Server.post<TenantInterface>(`/tenants/org/${orgId}/tenant`, tenant);
  }

  static async createTenants(orgId: number, tenants?: SaveTenantInterface[]): Promise<TenantInterface[]> {
    if (!tenants || !tenants.length) {
      return [];
    }

    const batchSize = 500;
    if (tenants.length > batchSize) {
      const tenantBatches: SaveTenantInterface[][] = [];
      for (let i = 0; i < tenants.length; i += batchSize) {
        tenantBatches.push(tenants.slice(i, i + batchSize));
      }
      const tenantsResponse = await Promise.all(tenantBatches.map((batch) => this.createTenants(orgId, batch)));
      return tenantsResponse.flat();
    }

    return APIService.Server.post<TenantInterface[]>(`/tenants/org/${orgId}/tenants`, tenants);
  }

  static async getTenantsByLocationId(orgId: number, locationId: number) {
    return APIService.Server.get<TenantInterface[]>(`/tenants/org/${orgId}/location/${locationId}`);
  }

  static async getUniqueTenantsByPhone(orgId: number, locationIds: number[], where?: NormalizedFMSTenantInterface, includeUser?: boolean) {
    return APIService.Server.post<TenantInterface[]>(`/tenants/org/${orgId}/locations`, { locationIds, where, includeUser });
  }

  static async getTenantByExternalTenantId(orgId: number, locationId: number, externalTenantId: string) {
    return APIService.Server.get<TenantInterface>(`/tenants/org/${orgId}/location/${locationId}/external-tenant/${externalTenantId}`);
  }

  static async getTenantsByUserId(orgId: number, userId: number) {
    return APIService.Server.get<TenantInterface[]>(`/tenants/org/${orgId}/user/${userId}`);
  }

  static async updateTenant(orgId: number, locationId: number, tenantId: number, tenant?: NormalizedFMSTenantInterface) {
    return APIService.Server.put<TenantInterface>(`/tenants/org/${orgId}/location/${locationId}/tenant/${tenantId}`, tenant);
  }

  static async updateTenants(orgId: number, tenants: NormalizedFMSTenantInterface[]) {
    return APIService.Server.put<TenantInterface[]>(`/tenants/org/${orgId}/tenants`, tenants);
  }

  static async deleteTenant(orgId: number, locationId: number, tenantId: number) {
    return APIService.Server.delete<TenantInterface>(`/tenants/org/${orgId}/location/${locationId}/tenant/${tenantId}`);
  }

  static async deleteTenants(orgId: number, tenantIds: number[]) {
    return APIService.Server.delete<TenantInterface[]>(`/tenants/org/${orgId}/tenants`, null, tenantIds);
  }
}
